module.exports = __webpack_public_path__ + "static/media/about-2.2d1debc8.jpg";